import React, {useEffect, useState, useContext} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { Scrollbar } from 'react-scrollbars-custom';
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
//import jQuery from 'jquery';
//import 'jquery-slimscroll';
//import SlimScroll from "react-jquery-slimscroll";



const Sidebar = () =>{
    const navigate = useNavigate();
    const currenturl = useLocation();
    const {user, setUser} = useContext(AuthContext);

    /*const [loggedname, setLoggedName] = useState("");
    const [loggedroleid, setLoggedRoleID] = useState(0);
    const [loggedemail, setLoggedEmail] = useState("");*/

    const scrollstyle = {
                        height: 'auto',
                        width: '100%',
                        position: 'right',
                        size: '7px',
                        color: '#ccc',
                        wheelStep: 10,
                        touchScrollStep: 100,
                        };


    useEffect(() =>{

        init();
		
        var $slimScrolls = $('.slimscroll');
        
        if($slimScrolls.length > 0) {
            
            var wHeight = $(window).height() - 60;
            $slimScrolls.height(wHeight);
            $('.sidebar .slimScrollDiv').height(wHeight);
            $(window).resize(function() {
                var rHeight = $(window).height() - 60;
                $slimScrolls.height(rHeight);
                $('.sidebar .slimScrollDiv').height(rHeight);
            });
        }
		

            $(document).on('mouseover', function(e) {
                e.stopPropagation();
                if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                    var targ = $(e.target).closest('.sidebar, .header-left').length;
                    if (targ) {
                        $('body').addClass('expand-menu');
                        $('.subdrop + ul').slideDown();
                    } else {
                        $('body').removeClass('expand-menu');
                        $('.subdrop + ul').slideUp();
                    }
                    return false;
                }
            });

            if($('#btnFullscreen').length > 0) {
                document.getElementById('btnFullscreen').addEventListener('click', function() {
                    toggleFullscreen();
                });
            }
        //SlimScroll($);
        
        
        /*const userinfo = localStorage.getItem("userinfo");

        if(userinfo != "" && userinfo != null && userinfo != undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            setLoggedRoleID(loggeduserdata.role_id);
            setLoggedEmail(loggeduserdata.email);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }*/

    }, []);

    const init = () =>{

		/*var Sidemenu = function() {
			this.$menuItem = $('.sidebar-menu a');
		};
		
		var $this = Sidemenu;
		$('.sidebar-menu a').on('click', function(e) {
			if($(this).parent().hasClass('submenu')) {
				e.preventDefault();
			}
			if(!$(this).hasClass('subdrop')) {
				$('ul', $(this).parents('ul:first')).slideUp(250);
				$('a', $(this).parents('ul:first')).removeClass('subdrop');
				$(this).next('ul').slideDown(350);
				$(this).addClass('subdrop');
			} else if($(this).hasClass('subdrop')) {
				$(this).removeClass('subdrop');
				$(this).next('ul').slideUp(350);
			}
		});
		$('.sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');*/
	}

	const toggleFullscreen = () =>{
		if (!document.fullscreenElement) 
		{
			document.documentElement.requestFullscreen();
		} 
		else 
		{
			if (document.exitFullscreen) 
			{
				document.exitFullscreen();
			}
		}
	}

    const handleSignout = () =>{
        //localStorage.removeItem('cpmstoken');
        sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');

        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return(
        <div className="sidebar" id="sidebar">
			{/*<div className="modern-profile p-3 pb-0">
				<div className="sidebar-nav mb-3">
					<ul className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent"
						role="tablist">
						<li className="nav-item"><a className="nav-link active border-0" href="#">Menu</a></li>
						<li className="nav-item"><a className="nav-link border-0" href="chat.html">Chats</a></li>
						<li className="nav-item"><a className="nav-link border-0" href="email.html">Inbox</a></li>
					</ul>
				</div>
			</div>*/}
			{/*<div className="sidebar-header p-3 pb-0 pt-2">
				<div className="d-flex align-items-center justify-content-between menu-item mb-3">
					<div className="me-3">
						<a href="calendar.html" className="btn btn-icon border btn-menubar">
							<i className="ti ti-layout-grid-remove"></i>
						</a>
					</div>
					<div className="me-3">
						<a href="chat.html" className="btn btn-icon border btn-menubar position-relative">
							<i className="ti ti-brand-hipchat"></i>
						</a>
					</div>
					<div className="me-3 notification-item">
						<a href="activities.html" className="btn btn-icon border btn-menubar position-relative me-1">
							<i className="ti ti-bell"></i>
							<span className="notification-status-dot"></span>
						</a>
					</div>
					<div className="me-0">
						<a href="email.html" className="btn btn-icon border btn-menubar">
							<i className="ti ti-message"></i>
						</a>
					</div>
				</div>
			</div>*/}
			<div className="sidebar-inner slimscroll">
                <Scrollbar style={scrollstyle}>
                    <div id="sidebar-menu" className="sidebar-menu">
                        {/*<ul>
                            <li className="clinicdropdown">
                                <div className="profile-data">
                                    <img src={userlogo} className="img-fluid" alt="Profile" />
                                    <div className="user-names">
                                        <h5>{loggedname}</h5>
                                        {loggedroleid === 1 ?
                                            <h6>Super Admin</h6>
                                        :
                                            (loggedroleid === 2 ?
                                                <h6>Sales Manager</h6>
                                            :
                                                (loggedroleid === 3 ?
                                                    <h6>Caller</h6>
                                                :
                                                    (loggedroleid === 4 ?
                                                        <h6>Team Lead</h6>
                                                    :
                                                        <h6>{loggedemail}</h6>
                                                    )
                                                )
                                            )
                                        }
                                    </div>
                                </div>
                            </li>
                        </ul>*/}
                        <ul className="mt-3">
                            <li>
                                {/*<h6 className="submenu-hdr">Main Menu</h6>*/}
                                <ul>
                                    <li>
                                        <Link to="/caller/dashboard" className={currenturl.pathname === '/caller/dashboard' ? 'active' : ''}>
                                            <i className="ti ti-home"></i>
                                            <span>Dashboard</span>
                                        </Link>
                                    </li>                                    
                                    <li>
                                        <Link to="/caller/leads" className={currenturl.pathname === '/caller/leads' ? 'active' : ''}>
                                            <i className="ti ti-location"></i>
                                            <span>Leads</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/caller/remarks" className={currenturl.pathname === '/caller/remarks' ? 'active' : ''}>
                                            <i className="ti ti-bell"></i>
                                            <span>Remarks</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/caller/notifications" className={currenturl.pathname === '/caller/notifications' ? 'active' : ''}>
                                            <i className="ti ti-bell"></i>
                                            <span>Notifications</span>
                                        </Link>
                                    </li>
                                    {/*<li>
                                        <Link to="/caller/activity-logs" className={currenturl.pathname === '/caller/activity-logs' ? 'active' : ''}>
                                            <i className="ti ti-activity"></i>
                                            <span>Activity Log</span>
                                        </Link>
                                    </li>*/}
                                    <li>
                                        <Link to="/caller/profile" className={currenturl.pathname === '/caller/profile' ? 'active' : ''}>
                                            <i className="ti ti-address-book"></i>
                                            <span>Profile</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <div onClick={handleSignout}>
                                            <i className="ti ti-power"></i>
                                            <span>Logout</span>
                                        </div>
                                    </li>                                   
                                </ul>
                            </li>

                            {/*<li>
                                <h6 className="submenu-hdr">Settings</h6>
                                <ul>
                                    <li>
                                        <Link to="/caller/password-update">
                                            <i className="ti ti-user-up"></i>
                                            <span>Password Update</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>*/}
                        </ul>
                    </div>
                </Scrollbar>
			</div>
		</div>
    )
}

export default Sidebar;